import { Typography, Box } from '@mui/material'
import { useState } from 'react'
import { useCrudForm } from '../../api/useCrudForm';
import { endpoints } from '../../api/endpoints';
import LockerChargeListTable from './LockerChargeTable';

const LockerChargeManagement = () => {

    const [lockerChargeList, setLockerChargeList] = useState<any | null>()
    const [lockerLocationList, setLockerLocationList] = useState<any | null>()
    const [loading, setLoading] = useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = useState<boolean>(false);
    const [skip, setSkip] = useState(0)
    const [count, setCount] = useState<any>(0);
    const [take, setTake] = useState(10)

    const { get } = useCrudForm();

    const refetchData = ({ isChargeDeducted, isPenalty, fromDate, toDate, customerName, lockerNo, location, penalOption, renewOption, transationType }: { transationType?: number, isChargeDeducted?: any, isPenalty?: any, fromDate?: any, toDate?: any, customerName?: any, lockerNo?: any, location?: any, penalOption?: any, renewOption?: any }) => {
        get({
            endpoints: endpoints.lockerCharge.list({ isChargeDeducted, isPenalty, fromDate, toDate, customerName, lockerNo, location, skip: skip * take, take: take, penalOption, renewOption, transationType }),
            onSuccess: (data: any) => {
                setLockerChargeList(data.data.list)
                setCount(data.data.count)
                setLoading(false)
                setButtonLoading(false)
            },
            onError: (error: any) => {
                console.log(error)
                setLoading(false)
                setButtonLoading(false)
            }
        })
    }

    return (
        <>
            <Typography variant="h5" component="h5" mb={1} fontWeight={600}>Locker Charge Management</Typography>
            <Box sx={{ width: "100%", padding: "24px 12px", background: "white", borderRadius: "5px" }} my={2}>
                <LockerChargeListTable refetchData={refetchData} loading={loading} setLoading={setLoading} buttonLoading={buttonLoading} setButtonLoading={setButtonLoading} lockerLocationList={lockerLocationList} setLockerLocationList={setLockerLocationList} skip={skip} take={take} setTake={setTake} setSkip={setSkip} count={count} rows={lockerChargeList} />
            </Box>
        </>
    )
}

export default LockerChargeManagement
